module.exports = __webpack_public_path__ + "img/medal.87b9abbb.png";